/**
 * Application routes.
 *
 * Every dashboard section has its own URL (see `dashboardSections.js`) so the
 * sidebar, the browser history and shared links all point at the same place.
 * Detail screens carry their identifier in the path, which keeps them
 * bookmarkable and safe to refresh.
 */

// Auth
export const HOME = '/';
export const LOGIN = '/login';
export const LOGOUT = '/logout';
export const FORGOT_PASSWORD = '/forgot-password';
// Opened from the reset email: /reset-password?token=...
export const RESET_PASSWORD = '/reset-password';

// Dashboard entry point — redirects to the first section the user may see
export const DASHBOARD = '/dashboard';

// Dashboard sections
export const APPROVED_CABINETS = '/approved-cabinets';
export const UNAPPROVED_CABINETS = '/unapproved-cabinets';
export const ORDERS = '/orders';
export const INVOICE_REPORTS = '/invoice-reports';
export const CUSTOMERS = '/customers';
export const KIOSKS = '/kiosks';
export const ADVERTISEMENTS = '/advertisements';
export const USERS = '/users';
export const PERMISSIONS = '/permissions';
export const ROLES = '/roles';
export const COUPON_CODES = '/coupon-codes';
export const PRICING = '/pricing';

// Detail screens (`:param` is filled in with the builders below)
export const CABINET_DETAILS = '/cabinets/:cabinetSn';
export const CUSTOMER_DETAILS = '/customers/:uuid';
export const ORDER_DETAILS = '/orders/:orderId';
export const USER_DETAILS = '/users/:uuid';

// Path builders — always use these instead of composing URLs by hand
export const cabinetDetailsPath = (cabinetSn) =>
  `/cabinets/${encodeURIComponent(cabinetSn)}`;

export const customerDetailsPath = (uuid) =>
  `${CUSTOMERS}/${encodeURIComponent(uuid)}`;

export const orderDetailsPath = (orderId) =>
  `${ORDERS}/${encodeURIComponent(orderId)}`;

export const userDetailsPath = (uuid) => `${USERS}/${encodeURIComponent(uuid)}`;
